<template>
	<v-container fluid class="blue-grey lighten-5">
		<v-container grid-list-lg>
			<v-row class="mt-5 font-weight-black black--text text-xs-center">
				<h1>رقم‌سازان در یک نگاه</h1>
			</v-row>
			<v-divider class="mt-5"></v-divider>
			<v-row>
				<pre>
				<h3 class="font-weight-light subheading text-justify black--text mt-5"
					style="white-space: pre-line;">شرکت رقم‌سازان با بیش از ۳۰ سال تجربه، یکی از پیشگامان توسعه نرم‌افزارهای مالی و فروشگاهی در ایران است. ما با ارائه‌ی محصولات موفقی مانند پازارپلاس (نرم‌افزار حسابداری و فروش تحت ویندوز) و پازارکلاد (راهکار حسابداری و مدیریتی تحت کلاد به صورت SaaS)، به کسب‌وکارهای کوچک و متوسط کمک می‌کنیم تا ساده‌تر، سریع‌تر و امن‌تر مدیریت شوند.

					در رقم‌سازان، کیفیت، سهولت استفاده، امنیت داده‌ها و پاسخگویی به نیاز واقعی مشتریان، ارزش‌های اصلی ما هستند. ما باور داریم که هر کسب‌وکاری، شایسته‌ی دسترسی به ابزارهای مدرن و یکپارچه‌ی مدیریتی است. با تکیه بر تخصص فنی، تجربه‌ی گسترده و اعتماد هزاران مشتری در سراسر کشور، آینده‌ی کسب‌وکار شما را همراهی می‌کنیم.

					رقم‌سازان، همراه رشد و موفقیت کسب‌وکار شما.
				</h3>
				</pre>
			</v-row>
			<v-row class=" heading mt-5">
				<h2 class="black--text font-weight-bold text-xs-center">ماموریت ما</h2>
			</v-row>
			<v-row class="font-weight-light black--text subheading mt-5 mb-10">
				<ul class='mr-5'>
					<li class='pt-2'>ساده‌سازی فرآیندهای مالی و مدیریتی برای کسب‌وکارها</li>
					<li class='pt-2'>ارائه نرم‌افزارهایی کاربرپسند، امن و مقرون به‌صرفه</li>
					<li class='pt-2'>کمک به رشد و موفقیت مشتریان از طریق ابزارهای نوآورانه</li>
					<li class='pt-2'>ایجاد یک تجربه‌ی کاربری برتر در تمام محصولات و خدمات</li>
					<li class='pt-2'>همراهی مستمر با مشتریان از شروع تا توسعه‌ی پایدار</li>
				</ul>
			</v-row>
		</v-container>
	</v-container>
</template>
<script>
export default {
	name: "AboutDetails",
};
</script>
